import { Mapper } from '../../../common/ddd/mapper.base';
import { IWorkingSessionsAnalyticsActivityEnum } from '../../../common/enum/working-sessions/working-sessions-analytics-activity.enum';
import { formatDeviation } from '../../../common/utils/format-deviation.util';
import { SelfFocusScoreGoalEntity } from '../../../core/domain/entities/goals/score-goals/self-focus-score-goal.entity';
import { GetSelfGoalSummaryResponseDto } from '../../../interface/dtos/goals/get-self-goal-summaries.response.dto';

export interface ISelfFocusScoreGoalPersistenceResponse {
  [IWorkingSessionsAnalyticsActivityEnum.FocusPercentage]: string;
}

export class SelfFocusScoreGoalMapper
  implements Mapper<SelfFocusScoreGoalEntity, any>
{
  toDomain(
    record: ISelfFocusScoreGoalPersistenceResponse
  ): SelfFocusScoreGoalEntity {
    return SelfFocusScoreGoalMapper.toDomain(record);
  }

  static toDomain(
    record: ISelfFocusScoreGoalPersistenceResponse
  ): SelfFocusScoreGoalEntity {
    const entity = SelfFocusScoreGoalEntity.create({
      score: Number(
        record[IWorkingSessionsAnalyticsActivityEnum.FocusPercentage]
      ),
    });
    return entity;
  }

  toResponse(entity: SelfFocusScoreGoalEntity): GetSelfGoalSummaryResponseDto {
    return SelfFocusScoreGoalMapper.toResponse(entity);
  }

  static toResponse(
    entity: SelfFocusScoreGoalEntity
  ): GetSelfGoalSummaryResponseDto {
    return {
      currentValue: `${entity.roundedScore}`,
      percentageDifference: entity.deviationFromGoalPercentage,
      formattedPercentageDifference: formatDeviation(
        entity.deviationFromGoalPercentage
      ),
    };
  }
}
